type Props = {
  message?: string;
  cssClass?: string;
};

export const Error = ({ message = '', cssClass = '' }: Props) => {
  return (
    <p className={cssClass}>
      Es ist ein Fehler aufgetreten. Die Kommentare konnten nicht geladen
      werden.
      {message}
    </p>
  );
};
